import FuturesPageSettings from '@/models/FuturesPageSettings'
import Api from '@/services/api'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    articleDetails: {},
    requestStatus: '',
    requestMsg: ''
  },

  mutations: {
    setRequestStatus (state, payload) {
      state.requestMsg = payload.msg
      state.requestStatus = payload.status
    },

    setList (state, records) {
      state.list = map(records, record => {
        if (record instanceof FuturesPageSettings) {
          return record
        } else {
          return new FuturesPageSettings(record)
        }
      })
    },

    setListMeta (state, meta) {
      state.listMeta = meta
    },

    refreshList (state) {
      state.list = []
    }
  },

  actions: {
    async getList ({ commit }, params) {
      const query = FuturesPageSettings.page(params.page || 1)
        .orderBy(params.sort)
        .limit(20)

      const res = await query.get()

      commit('setList', res.data)
      commit('setListMeta', res.meta)
    },

    async delete ({ commit }, id) {
      await Api.delete(`admin/app-futures/${id}`)
        .then(response => {
          let payload = { msg: 'Record Deleted.', status: 'error' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    }
  }
}
